import { useEffect, useState } from "react";

import { Typography } from "@mui/material";
import MUIPagination from "@mui/material/TablePagination";
import { useTheme } from "@mui/material/styles";

import useLocalization from "../../hooks/useLocalization";

const Pagination = ({
  totalCount,
  pageNumber,
  recordsPerPage,
  onPageChange,
  onRecordsPerPageChange,
  styles,
}) => {
  const theme = useTheme();
  const { getLabel } = useLocalization();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "8px",
        backgroundColor: theme.palette.primary.light,
        padding: "3px",
        ...styles,
      }}
    >
      <MUIPagination
        component="div"
        count={totalCount}
        page={pageNumber}
        rowsPerPage={recordsPerPage}
        onPageChange={(e, newPage) => onPageChange(newPage)}
        onRowsPerPageChange={(e) => onRecordsPerPageChange(e.target.value)}
      />
    </div>
  );
};

export default Pagination;
